import { useEffect, useMemo, useState } from 'react';
import { machinesApi } from '../../../lib/apis';
import { Machine } from '../../../types/machines';

export function useMachinesList() {
  const [items, setItems] = useState<Machine[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchAll = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await machinesApi.get<{ data: Machine[] }>('/machines');
      setItems(res.data);
    } catch (e: any) {
      setError(e.message || 'Failed to load machines');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return items;
    return items.filter(
      x =>
        x.name.toLowerCase().includes(q) ||
        x.location.toLowerCase().includes(q) ||
        x.serialNumber.toLowerCase().includes(q)
    );
  }, [items, query]);

  const total = filtered.length;
  const start = (page - 1) * pageSize;
  const end = start + pageSize;
  const pageData = filtered.slice(start, end);

  const remove = async (id: string) => {
    await machinesApi.delete(`/machines/${id}`);
    await fetchAll();
  };

  return {
    items: pageData,
    total,
    page,
    pageSize,
    setPage,
    setPageSize,
    query,
    setQuery,
    loading,
    error,
    refresh: fetchAll,
    remove,
  };
}
